export default {
  facebook: 'Facebook',
  instagram: 'Instagram',
  linkedin: 'Linkedin',
  twitter: 'Twitter',
  youtube: 'Youtube',
  'follow-instagram': 'Seguici su Instagram',
  'share-on': 'Condividi su',
  flyers: 'Volantini & flyer',
  'business-cards': 'Biglietti da visita',
  'books-magazines': 'Riviste, libri, cataloghi',
}
